import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_BLACK_LISTED_DOMAIN = "GET_BLACK_LISTED_DOMAIN";

export const service = async (data) => {
  const options: object = {
    url: `/Api/User/BlacklistDomain`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_BLACK_LISTED_DOMAIN, service, mock);
